import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const ChartComponent = ({ chartId, score_history, total }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!score_history || score_history.length === 0) return;

    const labels = score_history.map((_, index) => `Q${index + 1}`);
    const data = score_history.map((week) => {
      const key = Object.keys(week)[0];
      return week[key];
    });

    const stepSize = Math.ceil(total / 3);

    const ctx = chartRef.current.getContext("2d");
    let chartInstance = new Chart(ctx, {
      type: "line",
      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            borderColor: "#0070CC",
            borderWidth: 1,
            tension: 0.4,
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
        scales: {
          y: {
            beginAtZero: true,
            max: total,
            ticks: {
              stepSize: stepSize,
              color: "#D0D8DF",
              font: { family: "Poppins", size: 10, weight: "400" },
              callback: function (value) {
                const steps = [0, stepSize, stepSize * 2, total];
                return steps.includes(value) ? value : null;
              },
            },
            grid: { color: "#1B2C3A", drawBorder: false },
          },
          x: {
            grid: { display: false },
            ticks: {
              color: "#D0D8DF",
              font: { family: "Poppins", size: 10, weight: "400" },
            },
          },
        },
      },
    });

    return () => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    };
  }, [chartId, score_history, total]);

  return (
    <div className="chart-canvas-container">
      <canvas
        id={chartId}
        ref={chartRef}
        style={{ width: "100%", height: "100%" }}
      ></canvas>
    </div>
  );
};

export default ChartComponent;
